import { listAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
    createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle(() => ({
    container: {
        pl: 1,
    },
    item: {
        pl: 1,
    },
    icon: {
        //
    },
}));

const listTheme = defineMultiStyleConfig({ baseStyle });

export default listTheme;
